import React, { Component } from 'react';
import { Tabs, Tab, TabList, TabPanel } from 'react-tabs';
import { withTranslation, WithTranslation } from 'react-i18next'; // Import WithTranslation
import BodyPhotos from './bodyPhotos/BodyPhotos';
import PutBodyParam from './putBodyParam';
import ShowBodyParams from './showBodyParams';
import ShowDiagram from './showDiagramAll';
import Service from '../../services/bodyParams';

class BodyParams extends Component<WithTranslation> { // Add WithTranslation type

  state = {
    bodyParams: null,
    allBodyParams: null,
    gender: null,
    age: null,
    bmi: [],
  };

  componentDidMount() {
    this.updateData();
  }

  updateData = () => {
    Service.getActualBodyParams().then(
      (response) => {
        this.setState({
          bodyParams: response.data,
        });
      },
      (error) => {
        console.error("Error fetching body parameters:", error);
      }
    );

    Service.getAllBodyParams().then(
      (response) => {
        this.setState({
          allBodyParams: response.data,
        });
      },
      (error) => {
        console.error("Error fetching body parameters:", error);
      }
    );

    Service.getGender().then(
      (response) => {
        this.setState({
          gender: response.data.gender,
        });
      },
      (error) => {
        console.error("Error fetching gender:", error);
      }
    );

    Service.getAge().then(
      (response) => {
        this.setState({
          age: response.data.age,
        });
      },
      (error) => {
        console.error("Error fetching age:", error);
      }
    );

    Service.getBmiParams()
      .then((response) => {
        if (Array.isArray(response.data)) {
          const bmiData = response.data.map(item => ({
            ...item,
            date: item.date ? new Date(item.date).toISOString().split('T')[0] : null
          }));
          this.setState({ bmi: bmiData });
        } else {
          this.setState({ bmi: [] });
        }
      })
      .catch((error) => {
        console.error("Błąd pobierania BMI:", error);
        this.setState({ bmi: [] });
      });
  };

  render() {
    const { t } = this.props;
    return (
      <div className="card-container">
        <Tabs>
          <TabList>
            <Tab>{t("body_params.body_params")}</Tab>
            <Tab>{t("body_params.body_photos")}</Tab>
          </TabList>
          <TabPanel>
            <ShowBodyParams
              bodyParams={this.state.bodyParams}
              gender={this.state.gender}
              age={this.state.age}
              bmi={this.state.bmi}
              updateData={this.updateData}
            />
            <PutBodyParam clientId={null} updateData={this.updateData} />
            <ShowDiagram allBodyParams={this.state.allBodyParams} />
          </TabPanel>
          <TabPanel>
            <BodyPhotos />
          </TabPanel>
        </Tabs>
      </div>
    );
  }
}

export default withTranslation('global')(BodyParams);

